<template>
  <v-chip
    small
    label
    :color="viewData.color"
    text-color="white"
    class="mr-2"
  >
    {{ viewData.label }}
  </v-chip>
</template>

<script>
import transactionTypes from "@/helpers/transactionTypes";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    viewSettings: {
      PAID: {
        color: "orange",
        label: "Сплачено",
      },
      RECIEVED: {
        color: "green",
        label: "Отримано",
      },
    },
  }),
  computed: {
    viewData() {
      return this.viewSettings[transactionTypes[this.value]];
    },
  },
};
</script>